export default __webpack_public_path__ + "src/images/packages/safari-moon-lodge/eb80d535fda2d3a530a7016b4c751e65-2.jpg";